import BaseApi from './BaseApi';
import SsoApi from './SsoApi';

export default class UserApi extends BaseApi {
  static checkUser() {
    const msisdn = SsoApi.msisdn;
    const idDocNum = SsoApi.bin;
    return this.get(`/user/check/${idDocNum}/${msisdn}`);
  }
}
